(function fileModuleDefinition() {
    'use strict';

    angular.module('File', ['ui.router', 'Config', 'Entities', 'ErrorsExtend', 'dndLists', 'EmbedSrcAttr', 'DocumentViewer'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function fileConfig(config, $stateProvider, loginProvider) {
                $stateProvider.state('file-detail', {
                    url: '/File/Get/{id}',
                    templateUrl: config.resourceUrl('/views/file/detail.html'),
                    controller: 'FileDetailController',
                    authorize: true
                });

                $stateProvider.state('file-document-detail', {
                    url: '/Document/{id}/Version/{version}/files',
                    templateUrl: config.resourceUrl('/views/file/detail.html'),
                    controller: 'FileDocumentDetailController',
                    resolve: {
                        myDocument: function () {
                            return false;
                        }
                    },
                    authorize: true
                });

                $stateProvider.state('file-document-detail-one', {
                    url: '/Document/{id}/Version/{version}/files/{file}',
                    templateUrl: config.resourceUrl('/views/file/detail.html'),
                    controller: 'FileDocumentDetailController',
                    resolve: {
                        myDocument: function () {
                            return false;
                        }
                    },
                    authorize: true
                });
            }
        ]);
})();